// Constants
import { EMPTY_OBJECT } from 'tbase/app.constants'; // readers

import journalReader from 'tbase/readers/Journal';

var getJournalLabel = function getJournalLabel() {
  var journal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var journalName = journalReader.journalName(journal);
  var journalNumber = journalReader.journalNumber(journal);
  return journalName && journalNumber ? "".concat(journalNumber, " - ").concat(journalName) : undefined;
};

export default getJournalLabel;